"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResponse = void 0;
/**
 *
 * Takes the return of an async function and parsed it to an object
 * of {err: error, response: null, isSuccess: false} in case of failure or
 * {err: null, response: data, isSuccess: true} in case of success.
 *
 * The role of this function is to decouple the return type of the
 * async function from the state handling logic.
 *
 * All of the knowledge of the async function internals should be
 * contained in this module
 */
const parseResponse = async (promise) => {
    try {
        const res = await promise;
        if (!res.isSuccess) {
            return { err: res.error, response: null, isSuccess: false };
        }
        return { err: null, response: res.data, isSuccess: true };
    }
    catch (e) {
        throw new Error(`Unexpected exception in async request: ${e}`);
    }
};
exports.parseResponse = parseResponse;
//# sourceMappingURL=parseResponse.util.js.map